import React from 'react';
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from '../ui/dialog';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../ui/select';
import { Badge } from '../ui/badge';
import { Phone, Calendar, DollarSign, Loader2, MapPin, FileCheck, Mail } from 'lucide-react';
import { STATUS_OPTIONS, formatDate } from './constants';

export const ApplicationDetailDialog = ({ application, onClose, onStatusChange, updatingStatus }) => {
  const isCreditApp = application?.applicationType === 'preliminary_credit';
  const isContact = application?.productType === 'Ümumi sual';
  return (
    <Dialog open={!!application} onOpenChange={onClose}>
      <DialogContent className="sm:max-w-[600px] max-h-[90vh] overflow-y-auto">
        <DialogHeader>
          <div className="flex items-center gap-2 mb-1">
            <DialogTitle className="text-2xl">
              {isContact ? 'Mesaj ətraflı' : 'Müraciət ətraflı'}
            </DialogTitle>
            {isCreditApp && (
              <Badge className="bg-blue-100 text-blue-700 hover:bg-blue-100 border-blue-200" data-testid="app-type-badge">
                <FileCheck className="h-3 w-3 mr-1" />
                Kredit müraciəti
              </Badge>
            )}
          </div>
          <DialogDescription>Müraciət ID: {application?.id}</DialogDescription>
        </DialogHeader>
        {application && (
          <div className="space-y-6">
            <div className="grid grid-cols-2 gap-4">
              <div>
                <label className="text-sm font-semibold text-gray-600">Ad Soyad</label>
                <p className="text-base text-gray-900">{application.firstName} {application.lastName}</p>
              </div>
              {application.phone && (
                <div>
                  <label className="text-sm font-semibold text-gray-600">Telefon</label>
                  <div className="flex items-center space-x-2">
                    <Phone className="h-4 w-4 text-blue-600" />
                    <p className="text-base text-gray-900">{application.phone}</p>
                  </div>
                </div>
              )}
            </div>

            {application.email && (
              <div>
                <label className="text-sm font-semibold text-gray-600">Elektron ünvan</label>
                <div className="flex items-center space-x-2">
                  <Mail className="h-4 w-4 text-blue-600" />
                  <a
                    href={`mailto:${application.email}`}
                    className="text-base text-blue-700 hover:underline break-all"
                    data-testid="detail-email"
                  >
                    {application.email}
                  </a>
                </div>
              </div>
            )}

            {!isContact && (
              <div className="grid grid-cols-2 gap-4">
                <div>
                  <label className="text-sm font-semibold text-gray-600">Kredit məbləği</label>
                  <div className="flex items-center space-x-2">
                    <DollarSign className="h-4 w-4 text-green-600" />
                    <p className="text-base font-semibold text-gray-900">{application.loanAmount ? `${application.loanAmount} AZN` : '—'}</p>
                  </div>
                </div>
                <div>
                  <label className="text-sm font-semibold text-gray-600">Kredit müddəti</label>
                  <div className="flex items-center space-x-2">
                    <Calendar className="h-4 w-4 text-blue-600" />
                    <p className="text-base text-gray-900">{application.loanTerm ? `${application.loanTerm} ay` : '—'}</p>
                  </div>
                </div>
              </div>
            )}

            {application.address && (
              <div>
                <label className="text-sm font-semibold text-gray-600">Ünvan</label>
                <div className="flex items-start space-x-2">
                  <MapPin className="h-4 w-4 text-gray-500 mt-1 shrink-0" />
                  <p className="text-base text-gray-900" data-testid="detail-address">{application.address}</p>
                </div>
              </div>
            )}

            {isContact && (
              <div>
                <label className="text-sm font-semibold text-gray-600">Mesaj</label>
                <p className="text-base text-gray-700 bg-gray-50 p-3 rounded-lg">{application.message || 'Qeyd yoxdur'}</p>
              </div>
            )}

            <div>
              <label className="text-sm font-semibold text-gray-600">Müraciət tarixi</label>
              <p className="text-base text-gray-900">{formatDate(application.createdAt)}</p>
            </div>

            <div>
              <label className="text-sm font-semibold text-gray-600 mb-2 block">Status dəyişdir</label>
              <Select
                value={application.status}
                onValueChange={(value) => onStatusChange(application.id, value)}
                disabled={updatingStatus}
              >
                <SelectTrigger className="w-full" data-testid="status-change-select"><SelectValue /></SelectTrigger>
                <SelectContent>
                  {STATUS_OPTIONS.map(s => <SelectItem key={s} value={s}>{s}</SelectItem>)}
                </SelectContent>
              </Select>
              {updatingStatus && (
                <p className="text-xs text-gray-500 mt-2 flex items-center">
                  <Loader2 className="h-3 w-3 animate-spin mr-1" />
                  Yenilənir...
                </p>
              )}
            </div>
          </div>
        )}
      </DialogContent>
    </Dialog>
  );
};
